import '../../resources/css/site/SitePage.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadSiteSummary } from '../../actions/site/index';
import { forwardLogin, doLogout } from '../../actions/login/index';
import { getTabulatorHeight } from "../common/display-setting";
import { checkTableAuth, checkPageAuth } from '../../components/common/access-auth';
import SiteHeader from '../../components/site/SiteHeader';
import SiteList from '../../components/site/SiteList';
import SiteBlocks from '../../components/site/SiteBlocks';
import ModalConfirm from '../../components/common/ModalConfirm';
import ModalImportSetting from '../../components/site/ModalImportSetting';
import Loading from '../../components/common/Loading';
import { getDeviceData } from '../../actions/device';

class SitePage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      pageSize: 10,
      tabulatorDivHeight: 0
    }
  }

  setListHeight = () => {
    let listHeight = getTabulatorHeight(0, 120);
    this.setState({
      tabulatorDivHeight : listHeight < 600 ? 600 : listHeight
    });
}

  resizeInit = () => {
    window.onresize = () => {
      this.setListHeight();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { selectSite, accountRole, roleTableAuth, history , activePage } = this.props;

    if (prevProps.activePage !== activePage) {
      history.push(window.CONFIG.WEB_ROOT + activePage);
    }
    
    if (prevProps.selectSite !== selectSite) {
      
      if (selectSite !== 0) {
        // getDeviceData(authToken, accountInfo.account, selectSite);
        // add forward list is for auth is not neet change other forward
        checkPageAuth(this.props, accountRole, roleTableAuth);
      }
    }
    // if device data < 0, redirect to device page; else checkPageAuth
    // if(prevProps.deviceList !== deviceList){
    //   if(deviceList.length === 0 ){
    //     history.push(window.CONFIG.WEB_ROOT + "/device/monitor");
    //   } else {
    //     checkPageAuth(this.props, accountRole, roleTableAuth);
    //   }
    // }
  }

  componentDidMount() {
    const { loadSiteSummary, history, authToken, accountRole, roleTableAuth } = this.props;
    if (checkTableAuth('site', accountRole, roleTableAuth, 1)) {
      // has auth
      loadSiteSummary(authToken);
      this.setListHeight();
      this.resizeInit();
    } else {
      forwardLogin("Sorry yon can't access this page.");
      history.push(window.CONFIG.WEB_ROOT + "/Login");
    }
    
  }

  render() {
    const { loading, siteMode, siteSummaryList } = this.props;
    const { pageSize, tabulatorDivHeight } = this.state;

    let filterContent = <div className='area-filter'></div>;
    let pageContent = <Loading loading={loading}></Loading>;
    let modalDetailContent = <div className='modal-detail-empty'></div>;

    if (loading && siteSummaryList && siteSummaryList.length === 0) {
      // pageContent is loading
    } else if (siteMode === 'list') {
      pageContent = <SiteList pageSize={pageSize} tabulatorDivHeight={tabulatorDivHeight}></SiteList>;
    } else if (siteMode === 'blocks') {
      pageContent = <SiteBlocks></SiteBlocks>;
    }

    let monitor = (
      <div className='area-site-monitor'>
        <SiteHeader></SiteHeader>
        <div className='area-filter-bar' ref={(filterDiv) => { this.filterDiv = filterDiv }}>
          {filterContent}
        </div>
        <div className='area-page-content'>
          {pageContent}
        </div>
        <div className='area-modal-datail'>
          {modalDetailContent}
        </div>
        <ModalConfirm></ModalConfirm>
        <ModalImportSetting></ModalImportSetting>
      </div>
    );

    return (
      <div className='area-site-page area-page'>
        {monitor}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authToken: state.loginReducers.authToken,
    accountRole: state.loginReducers.accountRole,
    accountInfo: state.loginReducers.accountInfo,
    roleTableAuth: state.loginReducers.roleTableAuth,
    siteMode: state.siteReducers.siteMode,
    loading: state.siteReducers.loading,
    siteSummaryList: state.siteReducers.siteSummaryList,
    selectSite: state.siteReducers.selectSite,
    activePage: state.menuReducers.activePage,
    deviceList: state.deviceReducers.deviceList
  }
}

export default withRouter(connect(
  mapStateToProps,
  { loadSiteSummary, forwardLogin, doLogout, getDeviceData }
)(SitePage))
